import { MijnRoute } from '../../mijn-navigatie.model';

export const COLLECTION_UPDATE_PERMISSION: MijnRoute = {
    path: 'toestemming-updaten',
    navigationEvent: 'toIncassoUpdatePermission',
    regex: /^\/incasso\/toestemming-updaten$/,
    webcomponent: 'mijn-transacties-incasso-webcomponent',
    internalPath: '/toestemming-updaten'
};
